export type CalendarMode = 'week' | 'month';

export function addCalendarDays(value: string, amount: number) {
  const date = new Date(`${value}T12:00:00Z`);
  date.setUTCDate(date.getUTCDate() + amount);
  return date.toISOString().slice(0, 10);
}

// Keep dates on both sides of the focused period available to horizontal scrolling.
export function projectCalendarWindow(anchor: string, mode: CalendarMode) {
  const value = new Date(`${anchor}T12:00:00Z`);
  let focusStart: string; let focusEnd: string; let start: string; let end: string;
  if (mode === 'week') {
    focusStart = addCalendarDays(anchor, -((value.getUTCDay() + 6) % 7));
    focusEnd = addCalendarDays(focusStart, 6);
    start = addCalendarDays(focusStart, -7);
    end = addCalendarDays(focusEnd, 7);
  } else {
    const year = value.getUTCFullYear(); const month = value.getUTCMonth();
    focusStart = new Date(Date.UTC(year, month, 1, 12)).toISOString().slice(0, 10);
    focusEnd = new Date(Date.UTC(year, month + 1, 0, 12)).toISOString().slice(0, 10);
    start = new Date(Date.UTC(year, month - 1, 1, 12)).toISOString().slice(0, 10);
    end = new Date(Date.UTC(year, month + 2, 0, 12)).toISOString().slice(0, 10);
  }
  const count = Math.round((Date.parse(end) - Date.parse(start)) / 86400000) + 1;
  return { start, end, focusStart, focusEnd, days: Array.from({ length: count }, (_, index) => addCalendarDays(start, index)) };
}
